import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      {/* Top Section */}
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-screen-2xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
            {/* Left: Brand + Newsletter */}
            <div className="lg:w-[380px] flex-shrink-0">
              <Link to="/" className="inline-block mb-6">
                <span
                  className="text-3xl font-heading font-bold text-background-50"
                  style={{ fontFamily: 'var(--font-heading)' }}
                >
                  52吃瓜网<span className="text-accent-500">.</span>
                </span>
              </Link>

              <p className="text-foreground-300 text-sm mb-8 leading-relaxed">
                52吃瓜网 — 最新吃瓜爆料、网红黑料、明星塌房事件实时追踪平台。
                每日更新热门大瓜，不错过任何一个瓜。
              </p>

              {/* Newsletter */}
              <div className="flex items-center gap-2">
                <div className="relative flex-1 max-w-xs">
                  <input
                    type="email"
                    placeholder="输入邮箱订阅最新爆料"
                    className="w-full px-4 py-3 bg-foreground-800 border border-foreground-700 rounded-full text-sm text-background-100 placeholder-foreground-500 focus:outline-none focus:border-accent-500 transition-colors"
                  />
                </div>
                <button
                  type="button"
                  className="w-11 h-11 flex items-center justify-center bg-accent-500 text-background-50 rounded-full hover:bg-accent-600 transition-colors flex-shrink-0 cursor-pointer"
                  aria-label="订阅"
                >
                  <i className="ri-notification-3-line text-lg"></i>
                </button>
              </div>
            </div>

            {/* Right: Link Columns */}
            <div className="flex-1 grid grid-cols-2 sm:grid-cols-4 gap-8">
              {/* Column 1 */}
              <div>
                <h4 className="text-background-50 font-medium text-sm mb-4">热门分类</h4>
                <div className="flex flex-col gap-2">
                  {categories.slice(0, 4).map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="text-foreground-400 text-sm hover:text-background-100 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </div>

              {/* Column 2 */}
              <div>
                <h4 className="text-background-50 font-medium text-sm mb-4">快速链接</h4>
                <div className="flex flex-col gap-2">
                  <Link to="/" className="text-foreground-400 text-sm hover:text-background-100 transition-colors">
                    首页
                  </Link>
                  <Link to="/about" className="text-foreground-400 text-sm hover:text-background-100 transition-colors">
                    关于我们
                  </Link>
                  <a href="#app-download" className="text-foreground-400 text-sm hover:text-background-100 transition-colors cursor-pointer">
                    App下载
                  </a>
                  <Link to="/category/remen-baoliao" className="text-foreground-400 text-sm hover:text-background-100 transition-colors">
                    热门爆料
                  </Link>
                </div>
              </div>

              {/* Column 3 */}
              <div>
                <h4 className="text-background-50 font-medium text-sm mb-4">更多分类</h4>
                <div className="flex flex-col gap-2">
                  {categories.slice(4).map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="text-foreground-400 text-sm hover:text-background-100 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </div>

              {/* Column 4 */}
              <div>
                <h4 className="text-background-50 font-medium text-sm mb-4">联系我们</h4>
                <div className="flex flex-col gap-2">
                  <a href="mailto:tips@52chigua.com" className="text-foreground-400 text-sm hover:text-background-100 transition-colors">
                    <i className="ri-mail-line mr-1"></i> 爆料投稿
                  </a>
                  <span className="text-foreground-400 text-sm">
                    <i className="ri-customer-service-line mr-1"></i> 商务合作
                  </span>
                  <span className="text-foreground-400 text-sm">
                    <i className="ri-shield-check-line mr-1"></i> 侵权投诉
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-foreground-800">
        <div className="w-full px-4 md:px-6 py-6">
          <div className="max-w-screen-2xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-500 text-xs">
              &copy; 2026 52吃瓜网 版权所有 | 本站内容仅供娱乐参考，不构成任何建议
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center border border-foreground-700 rounded-lg text-foreground-400 hover:text-background-100 hover:border-background-100 transition-colors">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center border border-foreground-700 rounded-lg text-foreground-400 hover:text-background-100 hover:border-background-100 transition-colors">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center border border-foreground-700 rounded-lg text-foreground-400 hover:text-background-100 hover:border-background-100 transition-colors">
                <i className="fa-brands fa-tiktok text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center border border-foreground-700 rounded-lg text-foreground-400 hover:text-background-100 hover:border-background-100 transition-colors">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
            <div className="flex items-center gap-4">
              <a href="#" className="text-foreground-500 text-xs hover:text-background-100 transition-colors">
                隐私政策
              </a>
              <a href="#" className="text-foreground-500 text-xs hover:text-background-100 transition-colors">
                用户协议
              </a>
              <a href="#" className="text-foreground-500 text-xs hover:text-background-100 transition-colors" rel="nofollow">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}